import { motion } from "framer-motion";
import Overline from "./Overline";
import { reveal, revealStaggered, VIEW_60, VIEW_80 } from "./motion";

const DIFFERENTIATORS = [
  {
    title: "One vision, end to end",
    content: "Concept, 3D, motion, and code are crafted under a single creative direction — nothing is handed off, diluted, or templated.",
  },
  {
    title: "Art direction meets engineering",
    content: "Elentara works at the seam of cinematic art and real-time rendering, so the atmosphere you see is the technology itself.",
  },
  {
    title: "Performance as craft",
    content: "Reduced-motion fallbacks, mobile-aware scenes, and disciplined rendering budgets are part of the design — not an afterthought.",
  },
  {
    title: "The proof is the site you're on",
    content: "Every claim on this page is demonstrated by the page itself: the depth, the motion, the light. This website is the portfolio.",
  },
];


export const AboutDifferentiators = () => (
  <section data-testid="about-why" className="px-6 py-28 md:px-16 lg:px-24">
    <motion.div variants={reveal} initial="hidden" whileInView="show" viewport={VIEW_80}>
      <Overline>Why Elentara</Overline>
      <h2 className="font-display max-w-3xl text-3xl font-bold leading-tight text-[#F4F6FB] md:text-5xl">
        Different by construction, not by slogan.
      </h2>
    </motion.div>
    <div className="mt-16 grid gap-6 md:grid-cols-2">
      {DIFFERENTIATORS.map((d, i) => (
        <motion.article
          key={d.title}
          data-testid={`about-differentiator-${i + 1}`}
          variants={revealStaggered}
          initial="hidden"
          whileInView="show"
          viewport={VIEW_60}
          custom={i * 0.12}
          className="rounded-2xl border border-white/10 bg-[#12141C]/55 p-8 backdrop-blur-xl transition-colors duration-500 hover:border-[#06B6D4]/40 md:p-10"
        >
          <h3 className="font-display text-lg font-semibold text-[#F4F6FB] md:text-xl">{d.title}</h3>
          <p className="mt-4 text-sm leading-relaxed text-[#F4F6FB]/55">{d.content}</p>
        </motion.article>
      ))}
    </div>
  </section>
);

export default AboutDifferentiators;
